const plans = [
  {
    slug: 'plano_calculadora',
    nome: 'Plano Calculadora',
    description: 'Ferramenta de cálculo de honorários médicos com base nos valores da sua negociação. Realize a simulação dos seus procedimentos de maneira simples e rápida.',
    icon: 'smartphone',
    features: [
      {
        name: 'Calculadora de honorários médicos',
        active: true
      },
      {
        name: 'Registro de procedimentos cirúrgicos e consultas checar este no plano visão',
        active: false
      },
      {
        name: 'Identificação de prazos de recebimento e fluxo de caixa',
        active: false
      },
      {
        name: 'Conciliação automática de produção de recebimentos',
        active: false
      },
      {
        name: 'Relatório de divergência por fonte pagadora',
        active: false
      },
    ],
  },
  {
    slug: 'plano_gestao',
    nome: 'Plano Gestão',
    description: 'Solução completa para a gestão dos seus recebíveis. Auxiliamos na identificação das divergências e apontamos quais valores devem ser renegociados com as operadoras e hospitais.',
    icon: 'insert_chart',
    features: [
      {
        name: 'Calculadora de honorários médicos',
        active: true
      },
      {
        name: 'Registro de procedimentos cirúrgicos e consultas checar este no plano visão',
        active: true
      },
      {
        name: 'Identificação de prazos de recebimento e fluxo de caixa',
        active: true
      },
      {
        name: 'Conciliação automática de produção de recebimentos',
        active: true
      },
      {
        name: 'Relatório de divergência por fonte pagadora',
        active: true
      },
    ],
  },
  {
    slug: 'plano_visao',
    nome: 'Plano Visão',
    description: 'Nossa solução gerencia seus procedimentos e consultas apresentando de forma simples o quanto e quando você receberá seus honorários médicos.',
    icon: 'attach_money',
    features: [
      {
        name: 'Calculadora de honorários médicos',
        active: true
      },
      {
        name: 'Registro de procedimentos cirúrgicos e consultas checar este no plano visão',
        active: true
      },
      {
        name: 'Identificação de prazos de recebimento e fluxo de caixa',
        active: false
      },
      {
        name: 'Conciliação automática de produção de recebimentos',
        active: false
      },
      {
        name: 'Relatório de divergência por fonte pagadora',
        active: false
      },
    ],
  }
]

export default plans
